import { login, getInfo } from '@/api/login'
import { getToken, setToken, removeToken, setUserInfo, removeUserInfo } from '@/utils/auth'
import { getIntegral } from '@/api/customer'
import { validatenull } from '@/utils/common'
const user = {
  state: {
    token: getToken(),
    info: null,
    integralValue: 0, //可用积分
    integralMoneyValue: 0 //积分转换可抵现金
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, info) => {
      state.info = info
    },
    SET_INTEGRAL_VALUE: (state, integralValue) => {
      state.integralValue = integralValue
    },
    SET_INTEGRALMONEY_VALUE: (state, integralMoneyValue) => {
      state.integralMoneyValue = integralMoneyValue
    }
  },

  actions: {
    // 登录
    Login({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data)
          .then((res) => {
            setToken(res.data.appToken)
            commit('SET_TOKEN', res.data.appToken)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            commit('SET_USER', res.data)
            setUserInfo(res.data)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    IntegralData({ commit }) {
      return new Promise((resolve, reject) => {
        getIntegral()
          .then((res) => {
            if (!validatenull(res.data)) {
              if (!validatenull(res.data.avaliableIntegral)) {
                commit('SET_INTEGRAL_VALUE', res.data.avaliableIntegral)
              }
              if (!validatenull(res.data.integralChangeMoney)) {
                commit('SET_INTEGRALMONEY_VALUE', res.data.integralChangeMoney)
              }
            }
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_USER', null)
        commit('SET_INTEGRAL_VALUE', 0)
        commit('SET_INTEGRALMONEY_VALUE', 0)
        removeUserInfo()
        removeToken()
        localStorage.removeItem('home-use-device-sf002')
        resolve()
      })
    }
  }
}

export default user
